import * as React from 'react';

import { useIntl } from 'react-intl';
import { Route, Switch } from 'react-router-dom';

import { OAUTH_CALLBACK } from '../paths';

import { FourOhFour, Landing, Loading } from 'common/components';

const AboutUs = (locale = 'en') =>
  React.lazy(() =>
    import(`../static/${locale}/AboutUs` /* webpackChunkName: "about_us" */),
  );

const NewCheckoutPage = React.lazy(() =>
  import(
    '../commerce/components/checkout-page'
    /* webpackChunkName: "new_checkout_page" */
  ),
);

const ConfirmationPage = React.lazy(() =>
  import(
    '../confirmation/components/confirmation-page' /* webpackChunkName: "confirmation_page" */
  ),
);

const Contactus = (locale = 'en') =>
  React.lazy(() =>
    import(
      `../static/${locale}/Contactus` /* webpackChunkName: "contact_us" */
    ),
  );

const GeneralTermsAndConditions = (locale = 'en') =>
  React.lazy(() =>
    import(
      `../static/${locale}/GeneralTermsAndConditions` /* webpackChunkName: "general_terms_and_conditions" */
    ),
  );
// const HotelDetails = React.lazy(() =>
//   import(
//     '../hotels/components/Details' /* webpackChunkName: "hotel_details" */
//   ),
// );
// const HotelsSearchResultsContainer = React.lazy(() =>
//   import(
//     '../hotels/components/HotelsSearchResultsContainer' /* webpackChunkName: "hotel_search_results" */
//   ),
// );
const LegalDisclosures = (locale = 'en') =>
  React.lazy(() =>
    import(
      `../static/${locale}/LegalDisclosures` /* webpackChunkName: "legal_disclosures" */
    ),
  );

const NewsletterPage = (locale = 'en') =>
  React.lazy(() =>
    import(
      `../static/${locale}/NewsletterPage` /* webpackChunkName: "newsletter_page" */
    ),
  );
const OauthHandler = React.lazy(() =>
  import(
    '../auth/components/OauthHandler' /* webpackChunkName: "oauth_handler" */
  ),
);
const Press = (locale = 'en') =>
  React.lazy(() =>
    import(`../static/${locale}/Press` /* webpackChunkName: "press" */),
  );
const Privacy = (locale = 'en') =>
  React.lazy(() =>
    import(`../static/${locale}/Privacy` /* webpackChunkName: "privacy" */),
  );
const Results = React.lazy(() =>
  import(
    '../tours/components/results-page' /* webpackChunkName: "search_results_tours" */
  ),
);
const ShoreExcursions = React.lazy(() =>
  import(
    '../tours/components/ShoreExcursions' /* webpackChunkName: "shore_excursions" */
  ),
);
const TermsOfUse = (locale = 'en') =>
  React.lazy(() =>
    import(
      `../static/${locale}/TermsOfUse` /* webpackChunkName: "terms_of_use" */
    ),
  );
const TourDetails = React.lazy(() =>
  import(
    '../tours/components/DetailsPage' /* webpackChunkName: "tour_details" */
  ),
);

const UserProfile = React.lazy(() =>
  import(
    '../auth/components/UserProfile' /* webpackChunkName: "user_profile" */
  ),
);
const Verification = React.lazy(() =>
  import(
    '../common/components/Verification' /* webpackChunkName: "verification" */
  ),
);

const Routes = () => {
  const intl = useIntl();
  return (
    <React.Suspense fallback={<Loading />}>
      <Switch>
        <Route exact={true} path="/:lang(en|de)?" component={Landing} />
        {/* <Route
        exact={true}
        path="/:lang?/hotels/:city"
        component={HotelsSearchResultsContainer}
      /> */}
        <Route
          exact={true}
          path="/:lang?/new/checkout/:step(personal_info|traveler_info|questions|payment)"
          component={NewCheckoutPage}
        />
        <Route
          exact={true}
          path="/:lang?/confirmation"
          component={ConfirmationPage}
        />
        {/* <Route
        exact={true}
        path="/:lang?/hotels/:city/:hotelId"
        component={HotelDetails}
      /> */}
        <Route path="/:lang?/aboutUs" component={AboutUs(intl.locale)} />
        <Route
          path="/:lang?/newsletter"
          component={NewsletterPage(intl.locale)}
        />
        <Route path="/:lang?/contactUs" component={Contactus(intl.locale)} />

        <Route
          path="/:lang?/toursForCruises/:routeId"
          component={ShoreExcursions}
        />
        <Route path="/:lang?/termsOfUse" component={TermsOfUse(intl.locale)} />
        <Route
          path="/:lang?/generalTermsAndConditions"
          component={GeneralTermsAndConditions(intl.locale)}
        />
        <Route path="/:lang?/press" component={Press(intl.locale)} />
        <Route path="/:lang?/privacy" component={Privacy(intl.locale)} />
        <Route
          path="/:lang?/legalDisclosures"
          component={LegalDisclosures(intl.locale)}
        />
        <Route path="/:lang?/dashboard" component={UserProfile} />
        <Route path="/:lang?/verification" component={Verification} />
        <Route path={OAUTH_CALLBACK} component={OauthHandler} />
        <Route
          exact={true}
          path="/:lang?/:productType/:city"
          component={Results}
        />
        <Route
          exact={true}
          path="/:lang?/:productType/:city/:tourTitleId"
          component={TourDetails}
        />
        <Route path="/:lang?/fourOhFour" component={FourOhFour} />
        <Route component={FourOhFour} />
      </Switch>
    </React.Suspense>
  );
};

export default Routes;
